import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=000eeb72&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=000eeb72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000eeb72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('000eeb72')) {
      api.createRecord('000eeb72', component.options)
    } else {
      api.reload('000eeb72', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=000eeb72&scoped=true&", function () {
      api.rerender('000eeb72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26GQ6lqh8qp9c/JS/comp/DocBox.vue"
export default component.exports